import React, { useState } from "react";
import AppDataTable from "./AppDataTable";
import Icon from "@mdi/react";
import { mdiLockReset } from "@mdi/js";

export const PartnerList = ({ partners, openModal, onRefresh }) => {
  const [loading, setLoading] = useState(false);

  const columns = [
    { name: "Código", selector: (row) => `00${row.id}`, sortable: true, center: true, width: "90px" },
    { name: "Nombre", selector: (row) => `${row.firstName || ""} ${row.lastName || ""}`.trim(), sortable: true, center: true },
    { name: "Cód. registro", selector: (row) => row.user?.codigo ?? "N/A", sortable: true, center: true, width: "120px" },
    { name: "Email", selector: (row) => row.email ?? "N/A", sortable: true, center: true },
    { name: "Teléfono", selector: (row) => row.phoneNumber ?? "N/A", sortable: true, center: true, width: "130px" },
    { name: "Ciudad", selector: (row) => row.city?.name ?? "N/A", sortable: true, center: true, width: "120px" },
    { name: "Empresa", selector: (row) => row.partnerCompany?.name ?? "N/A", sortable: true, center: true, width: "140px" },
    {
      name: "Acciones",
      cell: (row) => (
        <div className="flex flex-row space-x-2">
          <button
            onClick={() => openModal("reset", row)}
            className="flex items-center gap-1 bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded-md shadow-sm text-xs"
            title="Restaurar contraseña"
          >
            <Icon path={mdiLockReset} size={1.1} />
          </button>
        </div>
      ),
      center: true,
      width: "120px",
    },
  ];

  return (
    <div className="relative">
      {loading ? (
        <div className="flex justify-center items-center h-40">
          <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-blue-500 border-solid"></div>
        </div>
      ) : (
        <div className="border rounded-lg overflow-hidden">
          <AppDataTable
            columns={columns}
            noDataComponent={<p className="text-gray-500 py-4">No hay técnicos partner.</p>}
            data={partners}
            highlightOnHover
            customStyles={{
              headCells: {
                style: {
                  fontWeight: "700",
                  backgroundColor: "#eef2ff",
                  color: "#374151",
                  fontSize: "15px",
                  paddingTop: "12px",
                  paddingBottom: "12px",
                },
              },
              rows: {
                style: {
                  backgroundColor: "white",
                  "&:hover": { backgroundColor: "#f0f9ff" },
                  transition: "background-color 0.3s",
                },
              },
              cells: {
                style: {
                  fontSize: "14px",
                  color: "#4b5563",
                  paddingTop: "10px",
                  paddingBottom: "10px",
                  justifyContent: "center",
                  textAlign: "center",
                },
              },
            }}
          />
        </div>
      )}
    </div>
  );
};
